import { createSelector } from 'reselect'

// Entities (DB objects)
const userEntities = state => state.data._entities.users
const agendaEntities = state => state.data._entities.agendas
const appointmentEntities = state => state.data._entities.appointments
const professionalEntities = state => state.data._entities.professionals
const officeEntities = state => state.data._entities.offices
const reportEntities = state => state.data._entities.reports

const loggedUser = state => state.data.loggedUser
const agendas = state => state.data.agendas
const selectedAgenda = state => state.data.selectedAgenda
const appointmentsFromWeek = state => state.data.appointmentsFromWeek

export const getLoggedUser = createSelector(
  [userEntities, loggedUser],
  (_users, loggedUser) => !_users || !loggedUser ? null : _users[loggedUser]
)

export const getAgendaList = createSelector(
  [agendaEntities, professionalEntities, officeEntities, agendas],
  (_agendas, _professionals, _offices, agendas) => {
    if (!agendas) return []
    return Object.keys(_agendas).filter(a => agendas.indexOf(a) >= 0).map(id => {
      const a = _agendas[id]
      return {
        id,
        workingTimeType: a.workingTimeType,
        professional: _professionals[a.dtoProfessional],
        office: _offices[a.dtoOffice]
      }
    })
  }
)

export const getSelectedAgenda = createSelector(
  [selectedAgenda, getAgendaList],
  (selectedAgenda, agendas) => agendas.find(a => a.id === selectedAgenda)
)
export const getSelectedAgendaReports = createSelector(
  [selectedAgenda, reportEntities, appointmentEntities],
  (selectedAgenda, _reports, _appointments) => {
    if (!selectedAgenda || !_reports) return []
    return Object.keys(_reports).filter(id => id.startsWith(selectedAgenda)).map(id => {
      const r = _reports[id]
      return { ...r,
        id,
        appointments: r.dtoProfessionalAppointments.map(id => _appointments[id])
      }
    })
  }
)

export const getAppointmentsFromWeek = createSelector(
  [appointmentsFromWeek, appointmentEntities],
  (appointmentsFromWeek, _appointments) => {
    if (!appointmentsFromWeek || !_appointments) return []
    return Object.keys(_appointments).filter(id => appointmentsFromWeek.indexOf(id) >= 0).map(id => _appointments[id])
  }
)


// WEBPACK FOOTER //
// ./src/lib/reader.js